/**
 * WeaponSize enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file WeaponSize.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum WeaponSize {
  INVALID = 0,
  TINY = 1,
  SMALL = 2,
  MEDIUM = 3,
  LARGE = 4,
  HUGE = 5,
}